import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import "../styles.scss";

const AccountsReceivablePage = () => {
  const location = useLocation();

  useEffect(() => {
    if(location.hash) handleScrollToView(location.hash.slice(1))
  }, [location]);

  // ------------------ miscellaneous -------------------
  const handleScrollToView = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  // stepper


const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  // ...theme.applyStyles('dark', {
  //   backgroundColor: theme.palette.grey[700],
  // }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      <strong>
        {icons[String(props.icon)]}
      </strong>
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Accounts Receivable | Lusid</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #253f83;
      --blue-btn-hover: #0d67e3;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 60px 20px;
      margin-bottom: 40px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 38px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
    .hero .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 10px;
      padding: 14px 38px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .hero .cta-main:hover {
      background: var(--blue-btn-hover);
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 36px;
      letter-spacing: -0.5px;
    }
    .ar-features-row {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ar-feature {
      background: var(--blue-light);
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 32px 24px;
      min-width: 260px;
      max-width: 340px;
      flex: 1 1 260px;
      text-align: left;
      margin-bottom: 10px;
      color: var(--grey-main);
    }
    .ar-feature h3 {
      color: var(--blue-main);
      font-size: 1.15em;
      margin-bottom: 10px;
      font-weight: 700;
    }
    .ar-feature ul {
      margin: 0 0 0 18px;
      padding: 0;
      color: var(--blue-dark);
      font-size: 1em;
    }
    .ar-feature li {
      margin-bottom: 8px;
    }
    .ar-benefits-row {
      display: flex;
      flex-wrap: wrap;
      gap: 36px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ar-benefit {
      background: var(--white);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 26px 22px;
      min-width: 220px;
      max-width: 320px;
      flex: 1 1 220px;
      text-align: center;
      color: var(--blue-dark);
      font-size: 1.08em;
      font-weight: 600;
    }
    .ar-benefit span {
      display: block;
      font-size: 1.8em;
      margin-bottom: 8px;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 10px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-btn-hover);
    }
    .ar-how-row {
      display: flex;
      flex-wrap: wrap;
      gap: 32px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ar-how-step {
      background: var(--blue-light);
      border-radius: 14px;
      padding: 30px 18px;
      min-width: 220px;
      max-width: 320px;
      text-align: center;
      color: var(--blue-dark);
      flex: 1 1 220px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .ar-how-step h4 {
      color: var(--blue-main);
      margin-bottom: 10px;
      font-size: 1.12em;
      font-weight: 700;
    }
    .ar-integrations {
      text-align: center;
      margin: 40px 0 0 0;
      color: var(--blue-main);
      font-size: 1.1em;
    }
    .ar-integrations img {
      height: 32px;
      margin: 0 14px;
      vertical-align: middle;
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1000px) {
      .ar-features-row, .ar-benefits-row, .ar-how-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
    }
  </style>
</head>
<body>

  <section class="hero">
    <h1>Accounts Receivable Automation</h1>
    <p>
      Get paid faster, globally. LusidPay automates your AR process from invoice to cash, with payment links, reminders, and real-time tracking.
    </p>
    <button class="cta-main" onclick="window.location='/contact-us'">Request Demo</button>
  </section>

  <section class="section" id="ar-features">
    <div class="section-title">Why LusidPay for Accounts Receivable?</div>
    <div class="ar-features-row">
      <div class="ar-feature">
        <h3>Automated Invoicing & Collection</h3>
        <ul>
          <li>Create and send invoices in seconds</li>
          <li>Embed payment links in invoices</li>
          <li>Automated reminders & follow-ups</li>
        </ul>
      </div>
      <div class="ar-feature">
        <h3>Global Payments</h3>
        <ul>
          <li>Accept payments in 180+ countries</li>
          <li>Customers pay via bank transfer, card, or ACH</li>
          <li>Funds settle to your local bank account</li>
        </ul>
      </div>
      <div class="ar-feature">
        <h3>Real-Time Tracking & Reconciliation</h3>
        <ul>
          <li>Track invoice status and payments in real-time</li>
          <li>Automatic reconciliation with your accounting system</li>
          <li>Full audit trail for every transaction</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="section" id="ar-benefits">
    <div class="section-title">Benefits</div>
    <div class="ar-benefits-row">
      <div class="ar-benefit">
        <span>💸</span>
        Accelerate cash flow with faster, automated collections.
      </div>
      <div class="ar-benefit">
        <span>🌍</span>
        Get paid in your customers’ currency, settle in yours.
      </div>
      <div class="ar-benefit">
        <span>🔔</span>
        Reduce manual chasing with automated reminders and payment links.
      </div>
      <div class="ar-benefit">
        <span>📊</span>
        Complete visibility into receivables and outstanding invoices.
      </div>
    </div>
  </section>

  <section class="section" id="ar-how">
    <div class="section-title">How LusidPay AR Works</div>
    <div class="ar-how-row">
      <div class="ar-how-step">
        <h4>1. Create & Send Invoices</h4>
        <p>Generate professional invoices and send them instantly with embedded payment links.</p>
      </div>
      <div class="ar-how-step">
        <h4>2. Customers Pay Online</h4>
        <p>Clients pay via bank transfer, ACH, or card in their preferred currency.</p>
      </div>
      <div class="ar-how-step">
        <h4>3. Automated Reminders</h4>
        <p>Send gentle reminders and follow-ups automatically until payment is received.</p>
      </div>
      <div class="ar-how-step">
        <h4>4. Reconcile & Report</h4>
        <p>Payments are auto-matched to invoices and synced with your accounting system.</p>
      </div>
    </div>
    <div class="ar-integrations">
      <strong>Integrates with:</strong>
      <img src="https://busybusy.com/wp-content/uploads/2022/12/QuickBooks-Desktop-logo2.png" alt="QuickBooks Desktop" title="QB Desktop">
      <img src="https://busybusy.com/wp-content/uploads/2022/06/QuickBooks-Online-Logo.png" alt="QuickBooks Online" title="QB Online">
      <img src="https://upload.wikimedia.org/wikipedia/en/9/9f/Xero_software_logo.svg" alt="Xero" title="Xero">
    </div>
  </section>

  <section class="cta-section" id="contact">
    <h2>Ready to automate your accounts receivable?</h2>
    <button class="cta-main" onclick="window.location='/contact-us'">Contact Us</button>
  </section>

</body>
</html>
` }} />
  )
}

export default AccountsReceivablePage;